/** @jsx jsx */
import React from 'react';
import { Global, css, jsx } from '@emotion/core';

export interface AlfredGlobalStylesProps {}

export const AlfredGlobalStyles: React.FC<AlfredGlobalStylesProps> = () => {
  return (
    <Global
      styles={css`
        // This is ugly, but will have to do for required
        // fields. Need some way that doesn't interfere
        // with the label since that makes testing
        // annoying and fragile. Maybe an upstream
        // commit to Magma with a "decorate" prop
        // available for Inputs?

        .snippet {
          background: #eee;
          border: 1px solid #ccc;
          font-family: monospace;
          padding: 0.1em;
          inline-size: min-content;
          overflow-wrap: break-word;
        }
        span:has(> div[data-testid*="-tooltip"]) {
            z-index:999;
        }
        
      `}
    />
  );
};
